module.exports = __webpack_public_path__ + "img/studywayIcon6.5b8646f6.png";